import React, { useContext, useMemo, useState } from "react";
import style from "./index.module.scss";
import LoadingWrapper from "../../../components/LoadingWrapper";
import CourseHeader from "../components/CourseHeader";
import SectionPicker from "../components/CourseLayout/components/SectionPicker";
import classNames from "classnames";
import { Button, Breadcrumb } from "antd";
import BreadLayout from "../../../components/BreadLayout";
import { useHistory, useParams } from "react-router-dom";
import { CourseContext } from "../Store";
import {
    getGroupList,
    GroupType,
    queryNoGroupStudent
} from "../../../service/group";
import useRequest from "../../../utils/useRequest";
import { GroupSettingsContext } from "./store";
import GroupsList from "./Components/GroupsList";
import MembersList from "./Components/MembersList";

export default function GroupSettings() {
    const { course } = useContext(CourseContext);
    const history = useHistory();
    const { flag } = useParams();
    const [search, setSearch] = useState(""); //小组列表查询条件
    const [noGroupSearch, setNoGroupSearch] = useState(""); //未分组成员列表查询条件

    const [mark, setMark] = useState(1);

    //参数列表
    const params = {
        courseNo: course.courseNo,
        courseSeq: course.courseSeq,
        weektimeId: course.weekTimeId
    };

    //小组列表
    const [groupList, { loading: groupListLoading }, updateGroupList] =
        useRequest(
            () =>
                getGroupList({
                    ...params,
                    groupName: search.trim(),
                    groupType: GroupType.base
                }),
            {},
            [course, search]
        );

    //未分配小组的学生列表
    const [noGroupStudent, { loading: noGroupLoading }, updateNoGroupStudent] =
        useRequest(
            () =>
                queryNoGroupStudent({
                    ...params,
                    groupType: GroupType.base
                }),
            {},
            [course]
        );

    //对未分配小组的学生进行筛选
    const filterNoGroupList = useMemo(() => {
        if (!noGroupStudent) return [];
        const search = noGroupSearch.trim();
        return noGroupStudent.filter(item => {
            if (item.name.indexOf(search) !== -1) return true;
            if (item.memberNo === search) return true;
            return false;
        });
    }, [noGroupSearch, noGroupStudent]);

    return (
        <BreadLayout
            breadcrumb={
                <>
                    <Breadcrumb.Item>
                        <a onClick={() => history.goBack()}>
                            {flag === "class" ? "学员管理" : "课程内容"}
                        </a>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>小组管理</Breadcrumb.Item>
                </>
            }>
            <LoadingWrapper loading={false} isEmpty={false}>
                {() => (
                    <GroupSettingsContext.Provider
                        value={{
                            groupList,
                            groupListLoading,
                            updateGroupList,
                            setSearch,
                            filterNoGroupList,
                            noGroupLoading,
                            updateNoGroupStudent,
                            setNoGroupSearch
                        }}>
                        <CourseHeader
                            title={course.courseName}
                            info={<SectionPicker />}
                        />
                        <div className={style.links}>
                            <Button
                                type="link"
                                className={classNames(style.link, {
                                    [style.current]: mark === 1
                                })}
                                onClick={() => setMark(1)}>
                                固定小组
                            </Button>
                        </div>
                        <div className={style.container}>
                            <GroupsList />
                            <MembersList />
                        </div>
                    </GroupSettingsContext.Provider>
                )}
            </LoadingWrapper>
        </BreadLayout>
    );
}
